import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

interface PrivacyState {
  /** Vertraulichkeitsmodus: personenbezogene Daten (.pii) werden unkenntlich gemacht. */
  confidential: boolean;
  toggle: () => void;
}

const STORAGE_KEY = 'm365adminbox.confidential';
const PrivacyContext = createContext<PrivacyState>({ confidential: false, toggle: () => {} });

// eslint-disable-next-line react-refresh/only-export-components
export const usePrivacy = (): PrivacyState => useContext(PrivacyContext);

export function PrivacyProvider({ children }: { children: ReactNode }) {
  const [confidential, setConfidential] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  });

  const toggle = useCallback(() => {
    setConfidential((current) => {
      const next = !current;
      try {
        localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
      } catch {
        /* localStorage nicht verfügbar — ignorieren */
      }
      return next;
    });
  }, []);

  return <PrivacyContext.Provider value={{ confidential, toggle }}>{children}</PrivacyContext.Provider>;
}
